import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { BadgeCheck, ArrowLeft, Loader2 } from 'lucide-react';
import { DealCard } from '../components/DealCard';
import { API } from '../config/apiBase';

// Reaproveita lista de marketplaces verificados.
const VERIFIED_STORES = ['mercado livre','mercadolivre','amazon','shopee','aliexpress','magalu','magazine luiza','magazineluiza','americanas','casas bahia','submarino','samsung'];

// Restaura nome bonito a partir do slug da URL.
function unslugify(slug) {
    return (slug || '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

export default function StorePage() {
    const { slug } = useParams();
    const niceName = unslugify(slug);
    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(true);
    const isVerified = VERIFIED_STORES.some(s => niceName.toLowerCase().includes(s));

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        fetch(`${API}/produtos?limit=60&store=${encodeURIComponent(niceName)}`)
            .then(r => r.json())
            .then(d => {
                if (!mounted) return;
                const list = Array.isArray(d?.deals) ? d.deals : Array.isArray(d) ? d : [];
                // Filtro defensivo (caso o backend ignore o param store)
                const filtered = list.filter(x => (x.store_name || '').toLowerCase().includes(niceName.toLowerCase()));
                setDeals(filtered.length ? filtered : list);
            })
            .catch(() => setDeals([]))
            .finally(() => mounted && setLoading(false));
        return () => { mounted = false; };
    }, [slug, niceName]);

    return (
        <div className="min-h-screen" style={{ background: 'var(--bg)' }}>
            <div className="site-container mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <Link to="/" className="inline-flex items-center gap-1.5 text-sm mb-4" style={{ color: 'var(--muted)' }}>
                    <ArrowLeft className="w-4 h-4" /> Voltar
                </Link>

                <header className="rounded-xl p-5 mb-6 flex items-center gap-3" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                    <div className="w-12 h-12 rounded-lg flex items-center justify-center font-bold text-lg" style={{ background: 'var(--surface-2)', color: 'var(--gold-2)' }}>
                        {niceName.charAt(0)}
                    </div>
                    <div className="flex-1">
                        <h1 className="text-xl font-bold flex items-center gap-2" style={{ color: 'var(--text)' }}>
                            {niceName}
                            {isVerified && <BadgeCheck className="w-5 h-5" style={{ color: '#2196F3' }} title="Loja verificada" />}
                        </h1>
                        <p className="text-xs mt-0.5" style={{ color: 'var(--muted)' }}>
                            Ofertas e cupons da loja {niceName} curados pela Super Vitrine.
                        </p>
                    </div>
                    <span className="text-xs px-2 py-1 rounded" style={{ background: 'var(--surface-2)', color: 'var(--muted)' }}>
                        {deals.length} oferta{deals.length === 1 ? '' : 's'}
                    </span>
                </header>

                {loading ? (
                    <div className="flex items-center justify-center py-16">
                        <Loader2 className="w-6 h-6 animate-spin" style={{ color: 'var(--gold-2)' }} />
                    </div>
                ) : deals.length === 0 ? (
                    <p className="text-center py-16" style={{ color: 'var(--muted)' }}>
                        Nenhuma oferta de {niceName} no momento.
                    </p>
                ) : (
                    <div className="flex flex-col sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-5">
                        {deals.map(d => (
                            <DealCard key={d.deal_id} deal={d} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
